export default __webpack_public_path__ + "resources/icons/n230-9a51.png";